import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StoreService {
  private readonly profileImageSource = new BehaviorSubject<string>('');
  readonly currentProfileImage = this.profileImageSource.asObservable();

  private previousRoute: string | null = null;

  private readonly localData = new BehaviorSubject<any>(null);

  readonly userActivated = new Subject<string>();
  readonly unsubscribeRoute = new Subject<boolean>();
  readonly isTabActivated = new Subject<boolean>();
  readonly addHeaderClass = new Subject<any>();
  readonly updateRole = new Subject<boolean>();
  readonly bannerData = new Subject<any>();

  private readonly isCiscoAdminFlag = new BehaviorSubject<any>(null);

  private readonly quizData = new BehaviorSubject<any>(null);

  private selectedPageNum: string = '';

  constructor() {}

  changeProfileImage(pic: string): void {
    this.profileImageSource.next(pic);
  }

  getPreviousRoute(): string | null {
    return this.previousRoute;
  }

  setPreviousRoute(route: string): void {
    this.previousRoute = route;
  }

  setUserObj(data: any): void {
    this.localData.next(data);
  }

  getUserObj(): Observable<any> {
    return this.localData.asObservable();
  }

  setCiscoAdminFlag(data: any, flag: boolean): void {
    this.isCiscoAdminFlag.next({ isCiscoAdmin: data, createChg: flag });
  }

  getIsciscoAdminFlag(): Observable<any> {
    return this.isCiscoAdminFlag.asObservable();
  }

  clearCiscoAdminVal(): void {
    this.isCiscoAdminFlag.next({ isCiscoAdmin: '' });
  }

  setQuizData(data: any): void {
    this.quizData.next({ response: data });
  }

  getQuizData(): Observable<any> {
    return this.quizData.asObservable();
  }

  setActivityChallengePageNum(pageNo: string): void {
    this.selectedPageNum = pageNo;
  }

  getActivityChallengePageNum(): string {
    return this.selectedPageNum;
  }

  clearActivityChallengePageNum(): void {
    this.selectedPageNum = '';
  }
}
